var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "star-holder" },
      [
        _vm._l(_vm.stars, function(star) {
          return [
            star === "f" ? _c("i", { staticClass: "fas fa-star" }) : _vm._e(),
            _vm._v(" "),
            star === "h"
              ? _c("i", { staticClass: "fas fa-star-half-o" })
              : _vm._e(),
            _vm._v(" "),
            star === "e"
              ? _c("i", { staticClass: "far fa-star unrated" })
              : _vm._e()
          ]
        })
      ],
      2
    ),
    _vm._v(" "),
    _c("div", [_vm._v("\n    " + _vm._s(_vm.rating + "/" + _vm.max) + "\n  ")])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c1030a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c1030a0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Results/Rating.vue
// module id = null
// module chunks = 